import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "../../../principal/customFetchBase";

export const fechaEvaluacionApi = createApi({
  reducerPath: "fechaEvaluacionApi",
  baseQuery: customFetchBase,
  tagTypes: ["Fecha Evaluacion"],
  endpoints: () => ({}),
});
